export default function nos_clients() {
    const NosClients =
        <>
            <div className="contentContainer troisMots">
                <div className='titreProjet'>
                    <h5 style={{ fontWeight: 'bold', marginBottom: '20px' }}>De l’idée à la diffusion, ALGEGO a la solution</h5>
                </div>
                <div>
                    <div className='mandat'>
                        <p className="vertical-timeline-element-subtitle">Découvrez ce que disent, en 3 mots, nos clients de leur expérience de collaboration avec ALGEGO : la gestion du changement.</p>
                    </div>
                </div>
                <div>
                    <div className='imageOfproject'>
                        <div className='iframeWrapper'>
                            <div style={{ padding: "56.25% 0 0 0", position: "relative" }}><iframe src="https://player.vimeo.com/video/1083648762?h=152549ed23&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} title="BIXI_INTRO_v2_1920x1080_20mbps"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
                        </div>
                    </div>
                </div>
            </div>
        </>

        return NosClients;
}